import React, { useContext, useEffect, useState } from "react";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { CurrentBlogData, GetBlogDetailsBySlug, GetBlogLookupList, GetWebAppBlogList } from "../../ApiServices/BlogApi/BlogAPI";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import MobileAppAd from "../../Components/MoblieAddComponent";
import { Helmet } from "react-helmet-async";
import { t } from "i18next";
import dayjs from "dayjs";


const Blogs = () => {
  const userID = localStorage.getItem("userID") || "";
  const { slug } = useParams();
  const [currentBlog, setCurrentBlog] = useState([]);
  const [blogList, setblogList] = useState([]);
  const [searchKeyWord, setSearchKeyword] = useState("");
  const location = useLocation();

  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  const navigate = useNavigate();




  useEffect(() => {
    GetCurrentBlog({
      pageNo: 0,
      pageSize: 20,
      sortingDirection: null,
      sortingColumnName: null,
      searchKeyword: null,
      fromDate: null,
      toDate: null,
    });

    GetBlogDetailsBySlugData()
  }, [selectedLanguageID, location, searchKeyWord]);



  const GetCurrentBlog = async () => {

    setLoader(true);

    const response = await GetBlogLookupList({
      pageNo: 0,
      pageSize: 10,
      searchKeyWord: searchKeyWord
    }, Number(selectedLanguageID), null);

    if (response?.statusCode === 200) {
      const blogs = response?.responseData?.data || [];
      setblogList(blogs);
    }

    setLoader(false);

  };

  const GetBlogDetailsBySlugData = async () => {

    setLoader(true);

    const response = await GetBlogDetailsBySlug(Number(selectedLanguageID), slug);

    if (response?.statusCode === 200) {
      const blogs = response?.responseData?.data || [];
      setCurrentBlog(blogs);

    }

    setLoader(false);

  };


  const filteredBlogs = blogList
    .filter(
      (data) =>
        data.blogTitle.toLowerCase().includes(searchKeyWord.toLowerCase()) &&
        data.blogTitle !== currentBlog?.blogTitle
    )
    .slice(0, 10);


  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };


  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": currentBlog?.metaTitle,
    "description": currentBlog?.metaDescription,
    "image": currentBlog?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": currentBlog?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": currentBlog?.canonicalURL
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": currentBlog?.metaTitle,
    "description": currentBlog?.metaDescription,
    "url": currentBlog?.canonicalURL,
    "image": currentBlog?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/spiritual-gyan/${currentBlog?.blogSlug}`
    }
  };

  const breadcrumbSchema =
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Spiritual Gyan",
        "item": "https://www.myomnamo.com/spiritual-gyan/"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": currentBlog?.metaTitle,
        "item": currentBlog?.canonicalTag
      }
    ]
  }



  return (
    <>
      <section className="page-header" style={{ marginBottom: "2rem" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <p className="page-header__title bw-split-in-left">
            {t("Spiritual Gyan")}
          </p>
        </div>
      </section>
      <Helmet>
        {/* Meta Title & Description */}
        <title>{currentBlog?.metaTitle}</title>


        <link rel="canonical" href={currentBlog?.canonicalTag} />
        {/* Meta description */}
        <meta name="description" content={currentBlog?.metaDescription} />

        <meta property="og:title" content={currentBlog?.metaTitle} />
        <meta property="og:description" content={currentBlog?.metaDescription} />
        <meta property="og:image" content={currentBlog?.blogImage} />
        <meta property="og:url" content={currentBlog?.canonicalTag} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentBlog?.metaTitle} />
        <meta name="twitter:description" content={currentBlog?.metaDescription} />
        <meta name="twitter:image" content={currentBlog?.blogImage} />

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>



      </Helmet>
      <div
        className="container"
        style={{ display: "felx", flexDirection: "column" }}
      >


        <div className="row">
          {/* Current Blog Section */}
          {currentBlog && (
            <div className="col-lg-8 col-md-5 col-sm-12">
              <div className="zoom-effect position-relative" style={{ width: "97%" }}>

                {/* Image */}
                <img
                  src={currentBlog.blogImage}
                  alt={currentBlog.blogTitle}
                  className="blog-img"
                  style={{
                    width: "100%",
                    height: "350px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />

                {/* Top Left Author */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    background: "rgba(0,0,0,0.5)",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    fontSize: "14px",
                  }}
                >
                  Author : {currentBlog.autherName}
                </div>

                {/* Top Right Date */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "rgba(0,0,0,0.5)",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    fontSize: "14px",
                  }}
                >
                  {dayjs(currentBlog.blogDate).format("DD/MM/YYYY")}
                </div>

                <div className="card-body">
                  <p
                    style={{ fontFamily: "Bricolage Grotesque" }}
                    dangerouslySetInnerHTML={{ __html: currentBlog.blog }}
                  ></p>
                </div>

              </div>
            </div>

          )}

          {/* Blog List Section */}
          <div
            className="col-lg-4 col-md-7 col-sm-12"
            style={{ padding: "0", margin: "0" }}
          >
            <div
              className="row title"
              style={{
                marginBottom: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >

              <div className="col-12" style={{ padding: "0" }}>
                {/* Search Bar */}
                <div
                  className="search-box"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "1",
                    maxWidth: "100%",
                    // marginRight: "10px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search"
                    className=" custom-search-input"
                    value={searchKeyWord}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  // style={{
                  //   width: "100%",
                  //   minWidth: "100px",
                  //   padding: "8px",
                  //   borderRadius: "5px",
                  // }}
                  />
                  {/* <FaSearch className="position-absolute top-50 end-0 me-3 translate-middle-y text-warning" /> */}
                </div>
              </div>
            </div>
            {/* Blog Cards */}
            <div className="row" style={{ padding: "0", margin: "0" }}>
              {blogList.map((data, index) => (
                <div
                  className="col-md-12 fade-in-up mb-3"
                  key={index}
                  style={{ padding: "0", margin: "0", cursor: "pointer" }}
                  onClick={() => {
                    setCurrentBlog(data);
                    navigate(`/spiritual-gyan/${data.blogSlug}`);
                  }}
                >
                  <div
                    className="card blog-card overflow-hidden card-shadow-sty rounded-3 border-1"
                    style={{ padding: "0", margin: "0" }}
                  >
                    <div
                      className="row g-0 "
                      style={{ padding: "0", margin: "0", justifyContent: 'left' }}
                    >
                      {/* <div
                        className="col-md-4 position-relative"
                        style={{ padding: "0", margin: "0" }}
                      >
                        <img
                          src={data.blogImage}
                          alt={data.blogTitle}
                          className="card-img blog-img object-fit-cover rounded-start"
                          height={"100%"}
                        />
                      </div> */}
                      <div className="col-md-12 d-flex flex-column  p-3">
                        <div >
                          {/* <span>Date: 14/03/2025</span> */}
                          <h5
                            className="card-title"
                            style={{
                              color: "black",
                              fontWeight: "500",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {data.blogTitle}
                          </h5>

                          <div className="d-flex justify-content-between ">

                            <p className="card-text  small   " style={{ fontSize: '11px' }}>
                              {/* {stripHtml(data.blog).length > 80
                              ? `${stripHtml(data.blog).substring(0, 80)}...`
                              : stripHtml(data.blog)} */}
                              {data.autherName}
                            </p>
                            <p className="text-end mb-0 textDate-btn " style={{ fontSize: '11px' }}>
                              <span

                              >
                                <i className="icofont-ui-calendar mx-1" ></i>
                                {data.createdOnDate}
                              </span>
                            </p>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <MobileAppAd />
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default Blogs;
